
<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px" transition="dialog-transition" style="border-radius: 40px;">
      <base-card>
        <template slot="title">
          {{ $t('projects.new_project') }}
        </template>

        <template v-slot:content>
          <v-form ref="projectForm" class="px-3">
            <v-text-field :placeholder="$t('projects.name_project')" solo flat class="black--text"
              style="font-weight: 900; font-size: large !important;" v-model="new_project.name" dense
              :rules="required"
            >
            </v-text-field>

            <v-row align="center" class="px-3">
              <b class="subtitle-1 black--text mb-7 mr-2">{{ $t('projects.responsible') }}: </b>
              <v-col cols="7" class="pa-0">
                <v-select class="rounder" multiple chips dense outlined rounded small-chips :items="users"
                  item-text="name" item-value="id" v-model="new_project.user_id"
                  :label="'Escolher ' + $t('projects.responsible').toLowerCase()" 
                  :loading="loading_users"
                  :readonly="loading_users"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-7 mr-2">{{ $t('clients.client') }}: </b>
              <v-col cols="7" class="pa-0">
                <v-select class="rounder" dense chips outlined rounded small-chips :items="clients" item-text="name"
                  item-value="id" v-model="new_project.client_id"
                  :label="'Selecione ' + $t('clients.client').toLowerCase()" :rules="required"
                  :loading="loading_clients"
                  :readonly="loading_clients"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row align="center" class="px-3">
              <b class="subtitle-1 black--text mb-0 mr-2"> {{ $t('projects.expected_conclusion_at') }}: </b>
              <v-col cols="8" class="pa-0">
                <vc-date-picker v-model="new_project.expected_conclusion_at">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-chip pill v-on="on" :rules="required" @click="togglePopover()">
                      {{ new_project.expected_conclusion_at ? $dayjs(new_project.expected_conclusion_at).format('DD/MM/YYYY') : 'selecione' }}
                    </v-chip>
                  </template>
                </vc-date-picker>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-0 mr-2"> Usar {{ $t('templates.template') }}: </b>
              <v-dialog v-model="dialogDate" width="300">
                    <template v-slot:activator="{ on, attrs }">
              <v-btn color="accent" small class="black--text elevation-0 text-capitalize" rounded
               v-bind="attrs" v-on="on"
              >
                Escolher {{ $t('templates.template') }}
              </v-btn>
              
              </template>

                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        {{ $t('templates.templates') }}
                      </v-card-title>
                      <div class="pa-2">
                        <v-select class="rounder" dense chips outlined rounded small-chips :items="templates" 
                        item-text="name" item-value="id" v-model="new_project.template_id" 
                        :label="'Selecione ' + $t('templates.template').toLowerCase()" :rules="required"
                        :loading="loading_templates"
                        :readonly="loading_templates"
                        >
                        </v-select>
                      </div>


                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="dialogDate = false">
                          {{ $t('save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                
                <v-chip label class='ml-2' v-if='new_project.template_id != null'>
                <!-- {{$t('templates.template')}}:  -->
                Selecionado: 
                  <b class="ml-1"> {{ templates.filter(objeto => objeto.id === new_project.template_id)[0].name }} </b>
                </v-chip>
                <v-btn class="ml-1" v-if="new_project.template_id" icon small @click="new_project.template_id = null" color="error">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-row>


            <v-row align="center" class="px-3">
              <b class="subtitle-1 black--text mb-7 mr-2"> {{ $t('projects.description') }} do {{ $t('projects.project')
              }}:</b>
            </v-row>
            <v-row align="center" class="px-3">
              <v-textarea class="rounder" rows="3" filled label="Escreva aqui" auto-grow
                v-model="new_project.description"></v-textarea>
            </v-row>

          </v-form>


        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelProject" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveProject" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DialogCreateProject',
  mixins: [validations],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,
      dialogDate: false,
      name_project: false,
      new_project: {},
      
      clients: [],
      templates: [],
      users: [],
      loading_clients: false,
      loading_users: false,
      loading_templates: false,

      new_project: {
        name: null,
        // user_id: null,
        client_id: null,
        expected_conclusion_at: null,
        template_id: null,
        description: null,
        color:null
      },
    }
  },
  methods: {
    getClients() {
      this.loading_clients = true
      Api.Client.index().then(r => r.data).then(d => {
        this.clients = [...d]
      }).catch(err => {
        console.log({ err });
      }).finally(() => {
        this.loading_clients = false
      })
    },
    getUsers(){
      this.loading_users = true
      Api.User.index().then(r=> r.data).then(d=> {
        this.users= [ ...d ]
      }).catch(err=>{
        console.log({err});
      }).finally(()=> {
        this.loading_users = false
      })
    },
    getTemplates(){
      this.loading_templates = true
      Api.Project.index({use_type: ['template']}).then(r=> r.data).then(d => {
        this.templates = [...d]
      }).finally(()=> {
        this.loading_templates = false
      })
    },
    saveProject() {
      if (this.$refs.projectForm.validate()){
        const posicao = this.templates.findIndex(template => template.id == this.new_project.template_id);
        this.new_project.color = this.templates[posicao].json_attributes.color
        console.log(this.new_project)
        Api.Project.create(this.new_project).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }else{
        const msg = {
          type: 'error',
          msg: 'Campos obrigatórios não foram preenchidos',
        }
        this.addNotification(msg)
      }
      
      //this.dialog = false
    },
    cancelProject() {
      this.dialog = false
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  filters: {
    formatDate: function (data) {
      if (data != null) {
        const date = new Date(data);
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return date.toLocaleDateString('pt-BR', options);
      } else {
        return 'Selecionar data'
      }

    }
  },
  mounted() {
    this.getClients();
    this.getUsers()
    this.getTemplates()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv, ov) {
      if (nv == false) {
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>
::v-deep.rounder.v-text-field--filled.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot {
  border: solid 1px #a5a5a5;
}

.row+.row {
  margin-top: 5px;
}

</style>